import React, { forwardRef } from "react";
import * as Primitive from "@radix-ui/react-label";
import { cn } from "../../lib/cn";

type LabelProps = React.ComponentPropsWithoutRef<typeof Primitive.Root>;

export const Label = forwardRef<React.ElementRef<typeof Primitive.Root>, LabelProps>(
  ({ className = "", ...props }, ref) => (
    <Primitive.Root
      ref={ref}
      className={cn("text-sm font-medium text-text data-[disabled]:text-text-subtle", className)}
      {...props}
    />
  )
);
Label.displayName = "Label";
